import React, { useEffect, useState } from 'react';
import flattenChildren from '../../helpers/flattenChildren';
import { useRouter } from 'next/router';
import useSeriesOfArticles from '../../contexts/useSeriesOfArticles';
import Link, { getFullyQualifiedArticlePath } from '../Link/Link';
import useGame from '../../../resources/js/contexts/useGame';
import Heading from '../../../resources/js/components/Heading/Heading';
import useGameSlug from '../../hooks/useGameSlug';

export function TitleSeriesOfArticles() {
  return null;
}
export function DescriptionSeriesOfArticles() {
  return null;
}

function getLinkComparer(links) {
  return JSON.stringify(
    links.map((link) => ({
      href: link.props.href,
      children: link.props.children.filter(
        (x) => typeof x === 'string' || x instanceof String,
      ),
    })),
  );
}

function SeriesOfArticles({ children }) {
  const router = useRouter();
  const { setNextLink, setPreviousLink } = useSeriesOfArticles();
  const game = useGame();
  const gameSlug = useGameSlug();

  const [links, setLinks] = useState([]);
  useEffect(() => {
    const newLinks = flattenChildren(children, game).filter(
      (x) => x.type === Link,
    );

    if (getLinkComparer(links) !== getLinkComparer(newLinks)) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setLinks(newLinks);
    }
  }, [children, links, game]);

  useEffect(() => {
    const currentLinkIndex = links.findIndex(
      (x) =>
        getFullyQualifiedArticlePath(x.props.href, gameSlug) === router.asPath,
    );
    setNextLink(
      currentLinkIndex < links.length - 1 ? links[currentLinkIndex + 1] : null,
    );
    setPreviousLink(currentLinkIndex > 0 ? links[currentLinkIndex - 1] : null);

    return () => {
      setNextLink(null);
      setPreviousLink(null);
    };
  }, [gameSlug, links, router.asPath, setNextLink, setPreviousLink]);

  const title = children?.find((x) => x.type === TitleSeriesOfArticles)?.props
    ?.children;

  const description = children?.find(
    (x) => x.type === DescriptionSeriesOfArticles,
  )?.props?.children;

  return (
    <nav aria-label={'Series of Articles'}>
      <Heading level={2} styleLevel={3} cssStyle={{ marginTop: '1.5em' }}>
        In this Series
      </Heading>
      {description}
      {title && <Heading level={3}>{title}</Heading>}
      {children}
    </nav>
  );
}
export default SeriesOfArticles;
